import merge from 'lodash/fp/merge';
import { Reducer } from 'redux';
import { getType } from '@anm/helpers/saga/typesafe-actions';

import { initialVideoFolderState } from '..';
import { renameFolderAsync } from '../../actions';
import { findAndUpdateFolder } from '../../helpers';
import { VideoFolderActions } from '../../types';

const renameFolderReducer: Reducer<
  typeof initialVideoFolderState,
  VideoFolderActions
> = (state = initialVideoFolderState, action) => {
  switch (action.type) {
    case getType(renameFolderAsync.request): {
      const params = action.payload;
      return {
        ...state,
        renameFolder: {
          ...state.renameFolder,
          params,
          error: null,
          isError: false,
          isPending: true
        }
      };
    }
    case getType(renameFolderAsync.success): {
      const renamedFolder = action.payload;

      const { folderId } = state.renameFolder.params!;

      return {
        ...state,
        data: findAndUpdateFolder(
          state.data!,
          folderId
        )(() => ({
          ...renamedFolder,
          isRenamed: true
        })),
        folderTree: {
          ...state.folderTree,
          data: findAndUpdateFolder(
            state.folderTree.data!,
            folderId
          )(folder => ({
            ...merge(folder, renamedFolder),
            isRenamed: true
          }))
        },
        renameFolder: {
          ...state.renameFolder,
          isPending: false
        }
      };
    }
    case getType(renameFolderAsync.failure): {
      const error = action.payload;

      return {
        ...state,
        renameFolder: {
          ...state.renameFolder,
          error,
          isError: true,
          isPending: false
        }
      };
    }
    default:
      return state;
  }
};

export default renameFolderReducer;
